import * as campaign from '@app/modules/soft-launch/services/campaign';
import * as payment from '@app/modules/soft-launch/services/payment';
import * as other from '@app/modules/soft-launch/services/other';

export default {
  campaign,
  payment,
  other,
};
